// extracted by mini-css-extract-plugin
module.exports = {"container":"_103a151b99--container--RtXLO","tabs":"_103a151b99--tabs--vDMuG"};